import request from '@/utils/request'


// export function Mechanism(pageNum) {
//   return request({
//     url: '/wx/weChatOrg/homePage?pageNum='+pageNum+'&pageSize=10',
//     method: 'get',
// 	// params: query
//   })
// }

/**
 * 患者录入病历信息
 * @param data
 * @returns {AxiosPromise}
 */
export function addEnterMedical(data) {
    return request({
        url: '/wx/enterMedical/add',
        method: 'post',
        data
    })
}

//距离优先
export function Distance(pageNum, latitude, longitude) {
    return request({
        // url: '/wx/weChatOrg/homePage?pageNum='+ pageNum +'&pageSize=10&latitude=30.67485&longitude=104.06291',
        url: '/wx/weChatOrg/homePageDistance?pageNum=' + pageNum + '&pageSize=10&latitude=' + latitude + '&longitude=' + longitude,
        method: 'get',
        // params: query
    })
}


export function wxInterface() {
    return request({
        url: '/wx/weChatOrg/getAccessToken',
        method: 'get',
        // params: query
    })
}


// 微信公众号 H5 登录（返回 token + 用户信息）
export function getInfoByWxCode(code) {
    return request({
        url: '/wx/mp/login?code=' + code,
        method: 'get'
    })
}


//每次跳转其他公众号获取一次点击
export function record(shujishu, name, zzjgdm, registerNo, gettime) {
    return request({
        url: '/wx/api/appoint_log?appointmentId=' + shujishu + '&channel=1&departmentCode=A30&departmentName=口腔科&doctorCard=513424195602090528&doctorName=赵敏&organizationName=' + name + '&organizationCode=' + zzjgdm + '&userId=' + registerNo + '&visitTime=' + gettime,
        method: 'get',
        // data: data
    })
}


//获取小程序链接
export function xcx(uuid, registerNo) {

    return request({
        url: '/wx/device/getHospitalScheme/' + uuid + '/' + registerNo,
        method: 'get',
        // data: data
    })
}


//获取轮播图片列表
export function getCarouselPicList() {
    return request({
        url: '/wx/hospitals/orgInformation/list',
        method: 'get',
        // data: data
    })
}

export function getWxTicket() {
    return request({
        url: '/wx/jump/findTicket',
        method: 'get'
    })
}

//免登录接口
export function avoidLogin(data) {
    return request({
        url: '/wx/ehc/avoidLogin',
        method: 'post',
        data
    })
}

//获取医保个人信息解密数据
export function getDecryptStr(data) {
    return request({
        url: '/wx/medicalInsurance/verificationUserData',
        method: 'post',
        data
    })
}

//通过身份证获取用户信息
export function getUserInfoByIdNo(idNo) {
    return request({
        url: '/wx/ehc/findUserInformation?idNo=' + idNo,
        method: 'get'
    })
}

/**
 * 获取已支付挂号记录列表
 */
export function getAlreadyPayRecord(data) {
    return request({
        url: '/internet_api/visit/alreadyPay/list',
        method: 'post',
        data
    })
}

//获取用药指导地址
export function getMedicationGuidance(data) {
    return request({
        url: '/wx/lnquiries/getMedicationGuidance',
        method: 'post',
        data
    })
}

//验证token
export function verifyUnitTestToken(params) {
    return request({
        url: '/wx/lnquiries/verifyUnitTestToken',
        method: 'get',
        params
    })
}



// WEBPACK FOOTER //
// ./src/api/home.js